import { GameType } from '@daymade/common-lib/dbEnums';
import { TDrawTypeNumberSetup } from '@daymade/common-lib/dbJsonModels';
import { useCallback, useState } from 'react';
import { IEntryLine } from 'types/Draws';

export default function useEntries(numberRanges: TDrawTypeNumberSetup) {
  const makeEmpty = () => ({
    type: GameType.LOTTERY as const,
    main: numberRanges.main.map(() => null),
    bonus: numberRanges.bonus.map(() => null),
  });

  // initial state: one empty entry
  const [entries, setEntries] = useState<IEntryLine[]>([makeEmpty()]);

  const addEntry = useCallback(() => {
    setEntries((prev) => [...prev, makeEmpty()]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [numberRanges]);

  const removeEntry = useCallback((idx: number) => {
    setEntries((prev) => prev.filter((_, i) => i !== idx));
  }, []);

  const updateEntry = useCallback((idx: number, payload: IEntryLine) => {
    setEntries((prev) =>
      prev.map((entry, i) =>
        i === idx
          ? {
              type: GameType.LOTTERY as const,
              main: [...payload.main],
              bonus: [...payload.bonus],
            }
          : entry
      )
    );
  }, []);

  return { entries, addEntry, removeEntry, updateEntry };
}
